import { Button, Stack, Typography } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { ADD_CLINIC } from "../../enums/ApiPaths";
import { LOGGED_IN_USER } from "../../enums/QueryKeys";
import useSubmit from "../../features/master/species/hooks/useSubmit";
import ChangeClinic from "../../features/profile/component/chips/ChangeClinic";
import usePrimaryColor from "../../hooks/usePrimaryColor";

export default function ClinicPickerDialog() {
  const { t } = useTranslation();
  const methods = useForm();
  const color = usePrimaryColor();
  const apiPath = ADD_CLINIC;
  const id = null;
  const queryKey = LOGGED_IN_USER;
  const { loading, submitCallback } = useSubmit(id, apiPath, queryKey);

  async function handleSubmit(data) {
    if (!data) return;
    const obj = {
      id: data.clinic.id,
    };
    submitCallback(obj);
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(handleSubmit)}>
        <Wrapper>
          <IoMdInformationCircleOutline color={color} size={120} />
          <Typography textAlign={"center"} variant="h6" fontWeight="bold">
            {t("PickAClinicTitle")}
          </Typography>
          <Typography textAlign={"center"} color="text.secondary">
            {t("PickAClinicDialogMessage")}
          </Typography>
          <ChangeClinic />
          <Button variant="contained" fullWidth type="submit">
            {t("Save")}
          </Button>
        </Wrapper>
      </form>
    </FormProvider>
  );
}

function Wrapper({ children }) {
  return (
    <Stack direction={"column"} alignItems={"center"} spacing={2}>
      {children}
    </Stack>
  );
}
